import { useEffect, useState } from "react";
export var useGetSteps = function () {
    var _a = useState([]), steps = _a[0], setSteps = _a[1];
    useEffect(function () {
        try {
            var stored = localStorage.getItem("steps");
            var parsed = stored ? JSON.parse(stored) : [];
            if (Array.isArray(parsed)) {
                setSteps(parsed);
            }
        }
        catch (_) { }
    }, []);
    return steps.map(function (step) { return ({
        id: step.id,
        name: step.step,
        state: step.state,
    }); });
};
